import { DEFAULT_INFERENCE_FORM } from "../../../../features/forge/constants";
import { InferenceParameters, InferenceQuality } from "../../../../types";
import { DimensionsType } from "../../constants";
import { ReferenceImageType } from "../../fields/References/constants";
import { formatReferenceImageForAPI } from "../../fields/References/utils";
import { STYLE_FIELD_NAME } from "../../fields/StyleSelection/constants";
import { FormWithStyle } from "../../fields/StyleSelection/types";
import {
  DEFAULT_FIELDS_STYLE,
  formatFormWithStyleValuesForAPI,
  formatInferenceParamsForFormWithStyle,
} from "../../fields/StyleSelection/utils";
import { getImageObject } from "../../utils/utils";

export const FORM_FIELDS_VIDEO = {
  STYLE: STYLE_FIELD_NAME,
  TARGET_FILE: "targetFile",
  DIMENSIONS: "dimensions",
  PROMPT_TEXT: "promptText",
  PROMPT_LANGUAGE: "promptLanguage",
  PERFORMANCE: "performance",
} as const;

export interface FormTypeVideo extends FormWithStyle {
  [FORM_FIELDS_VIDEO.TARGET_FILE]: ReferenceImageType;
  [FORM_FIELDS_VIDEO.DIMENSIONS]?: DimensionsType;
  [FORM_FIELDS_VIDEO.PROMPT_TEXT]?: string;
  [FORM_FIELDS_VIDEO.PROMPT_LANGUAGE]: string;
  [FORM_FIELDS_VIDEO.PERFORMANCE]: InferenceQuality;
}

export const DEFAULT_VIDEO_FORM_VALUES: FormTypeVideo = {
  ...DEFAULT_FIELDS_STYLE,
  [FORM_FIELDS_VIDEO.TARGET_FILE]: null,
  [FORM_FIELDS_VIDEO.DIMENSIONS]: [1024, 1024],
  [FORM_FIELDS_VIDEO.PROMPT_TEXT]: "",
  [FORM_FIELDS_VIDEO.PROMPT_LANGUAGE]: null,
  [FORM_FIELDS_VIDEO.PERFORMANCE]: "MEDIUM",
};

export const getDefaultFormVideoValues = () =>
  JSON.parse(JSON.stringify(DEFAULT_VIDEO_FORM_VALUES));

export const formatVideoFormValuesForAPI = (
  inputForm: FormTypeVideo,
): InferenceParameters => {
  const parameters: InferenceParameters = {
    ...DEFAULT_INFERENCE_FORM.parameters,
    ...formatFormWithStyleValuesForAPI(inputForm),
    generationType: "IMAGE_TO_VIDEO",
    batchSize: 1,
    prompt: inputForm[FORM_FIELDS_VIDEO.PROMPT_TEXT],
    promptLanguage: inputForm[FORM_FIELDS_VIDEO.PROMPT_LANGUAGE],
    width: inputForm[FORM_FIELDS_VIDEO.DIMENSIONS][0],
    height: inputForm[FORM_FIELDS_VIDEO.DIMENSIONS][1],
  };

  if (inputForm[FORM_FIELDS_VIDEO.TARGET_FILE]) {
    parameters.files = [
      formatReferenceImageForAPI(inputForm[FORM_FIELDS_VIDEO.TARGET_FILE]),
    ];
  }

  return parameters;
};

export const formatInferenceParamsForFormTypeVideo = async (
  params: InferenceParameters,
): Promise<Partial<FormTypeVideo>> => {
  const outputForm: Partial<FormTypeVideo> = {
    ...formatInferenceParamsForFormWithStyle(params),
  };

  if (params) {
    if (params.files?.length) {
      const file = params.files[0];
      const imageObject = await getImageObject(file.url);
      outputForm[FORM_FIELDS_VIDEO.TARGET_FILE] = {
        src: file.url,
        width: imageObject.width,
        height: imageObject.height,
      };
    }
    if (params.width && params.height) {
      outputForm[FORM_FIELDS_VIDEO.DIMENSIONS] = [params.width, params.height];
    }
    if (typeof params.prompt !== "undefined") {
      outputForm[FORM_FIELDS_VIDEO.PROMPT_TEXT] = params.prompt;
    }
    if (typeof params.promptLanguage !== "undefined") {
      outputForm[FORM_FIELDS_VIDEO.PROMPT_LANGUAGE] = params.promptLanguage;
    }
  }
  return outputForm;
};
